export default __webpack_public_path__ + "static/media/cards.b896b866.svg";